module.exports = __webpack_public_path__ + "5c18a80179041c61444e2d4fac6c09f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icn-indies-200.png
// module id = 1539
// module chunks = 0